module.exports = {
	"generation": 12,
	"links_in_ad": 4,
	"items": [
		{
			"id": 399,
			"name": "Professional Express Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/399-professional-express-logo-design",
			"price_from": 50
		},
		{
			"id": 3099,
			"name": "Corporate Business Card Design",
			"url": "https://studio.envato.com/explore/business-card-design/3099-corporate-business-card",
			"price_from": 40
		},
		{
			"id": 6136,
			"name": "Professional WordPress OnSite SEO",
			"url": "https://studio.envato.com/explore/wordpress-seo/6136-professional-wordpress-onsite-seo",
			"price_from": 100
		},
		{
			"id": 3746,
			"name": "Logo Vectorization, Customization & Improvements",
			"url": "https://studio.envato.com/explore/logo-customization/3746-logo-vectorization-customization-improvements",
			"price_from": 20
		},
		{
			"id": 1250,
			"name": "Professional Icon Set Design",
			"url": "https://studio.envato.com/explore/icon-set-design/1250-professional-icon-set-design",
			"price_from": 100
		},
		{
			"id": 38271,
			"name": "Up to 30 Second Voice Over Male American English",
			"url": "https://studio.envato.com/explore/voice-overs/38271-up-to-30-second-voice-over-male-american-english",
			"price_from": 50
		},
		{
			"id": 11264,
			"name": "Express Design & Template Customization",
			"url": "https://studio.envato.com/explore/customize-graphics/11264-express-design-customization-templates-graphic-files",
			"price_from": 20
		},
		{
			"id": 478,
			"name": "Hand-Drawn Lettering & Type Service",
			"url": "https://studio.envato.com/explore/lettering-calligraphy/478-hand-drawn-lettering-type",
			"price_from": 50
		},
		{
			"id": 9320,
			"name": "Android UI/UX App Design",
			"url": "https://studio.envato.com/explore/app-design/9320-android-ui-ux-app-design-or-android-xml-layout",
			"price_from": 200
		},
		{
			"id": 3292,
			"name": "Professional Company Brochure Design",
			"url": "https://studio.envato.com/explore/brochure-design/3292-professional-company-brochure-design",
			"price_from": 150
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./config/sites/studio-recommendations/graphicriver.json
// module id = 488
// module chunks = 1